import script from "./EditPrintTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditPrintTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./EditPrintTemplate.vue?vue&type=style&index=0&id=46c92ff0&lang=scss"

const __exports__ = script;

export default __exports__